import React, { useEffect, useState } from 'react'
import AppLayout from '../../../../layout/components/AppLayout'

import reportsServices from '../reportsServices';
import useSystemMasterList from '../../../../hooks/useSystemMasterList';
import PendingCounterByType from '../components/PendingCounterByType';

function GrievancePendingReportByTypePage() {

    const [reportData,setReportData] = useState(null);

    const [masters,getMasterLabel] = useSystemMasterList(['grievance-type','grievance-status']);

    const getPendingReport = () => {
        reportsServices.getPendingByType().then(res=>{
            setReportData(res.data);
        }).catch(error=>{
            console.log(error);
        })
    }

    useEffect(()=>{
        getPendingReport()
    },[])

    return (
        <AppLayout>
            <div className='container-fluid'>
                <div className='row mb-3'>
                    <div className='col-md-12'>
                        <div class="p-2 bg-dark text-center text-white rounded">
                            <h3 className='mb-0' >Total Pandency</h3>
                        </div>
                    </div>
                </div>
                {reportData && masters && <PendingCounterByType reportData={reportData} masters={masters} getMasterLabel={getMasterLabel} /> }
            </div>
        </AppLayout>
    )
}

export default GrievancePendingReportByTypePage